module.exports = __webpack_public_path__ + "static/media/MoonDark.55fc914f.svg";